export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/drill.202178f.svg";